import { type PaletteMode, type PaletteOptions, createTheme } from '@mui/material'
import { type TenantPaletteConfig } from '../../types'
import { paletteDhlLight } from './light'
import { paletteDhlDark } from './dark'

// DHL tenant light palette
const lightPalette = createTheme({
  palette: paletteDhlLight,
}).palette

// DHL tenant dark palette
const darkPalette = createTheme({
  palette: paletteDhlDark,
}).palette

/**
 * Internally used in our theme, but could also be used for react native integrations
 */
export const createDhlPalette = (mode: PaletteMode) => (mode === 'light' ? lightPalette : darkPalette)

/**
 * Process raw PaletteOptions into a full MUI Palette.
 * Use this in tenant palette files to pre-compute the processed palette at module load time.
 */
export const createDhlPaletteFromOptions = (options: PaletteOptions) => createTheme({ palette: options }).palette

/**
 * DHL tenant palette — uses the canonical DHL light and dark palettes.
 */
export const dhlPalette: TenantPaletteConfig = {
  light: createDhlPalette('light'),
  dark: createDhlPalette('dark'),
}
